import { createApi } from '@reduxjs/toolkit/query/react';
import { config } from '../../config/config';
import {
  GetQuizByUserIdRes,
  IQuizUserRequest,
} from '../../interfaces/quiz.interface';
import { baseQueryWithInterceptor } from '../utils/baseQueryWithInterceptor';

/**
 * Quiz API - Migrated to new /api/user/quiz endpoints
 *
 * Old endpoints (deprecated):
 * - GET  /api/quiz/user/:userId
 * - POST /api/quiz
 *
 * New endpoints:
 * - GET  /api/user/quiz           → Get my quiz
 * - GET  /api/user/quiz/:userId   → Get user's quiz
 * - POST /api/user/quiz           → Create/update quiz
 * - DELETE /api/user/quiz/:id     → Delete quiz
 */
const quizApi = createApi({
  reducerPath: 'quizApi',
  baseQuery: baseQueryWithInterceptor(`${config.API_BASE_URL}/user`),
  tagTypes: ['quiz'],

  endpoints: (builder) => ({
    getMyQuiz: builder.query<GetQuizByUserIdRes, void>({
      query: () => `/quiz`,
      providesTags: ['quiz'],
    }),
    getQuizByUserId: builder.query<GetQuizByUserIdRes, string>({
      query: (userId) => `/quiz/${userId}`,
      providesTags: ['quiz'],
    }),
    createOrUpdateQuiz: builder.mutation<GetQuizByUserIdRes, IQuizUserRequest>({
      query: (data: IQuizUserRequest) => ({
        url: `/quiz`,
        method: 'POST',
        body: data,
      }),
      invalidatesTags: ['quiz'],
    }),
    deleteQuiz: builder.mutation<void, string>({
      query: (quizId: string) => ({
        url: `/quiz/${quizId}`,
        method: 'DELETE',
      }),
      invalidatesTags: ['quiz'],
    }),
  }),
});

export const {
  useGetMyQuizQuery,
  useGetQuizByUserIdQuery,
  useCreateOrUpdateQuizMutation,
  useDeleteQuizMutation,
} = quizApi;

export default quizApi;
